import { filesApi } from '@/api/services'

/**
 * Upload via POD API → s3-utils POST /api/upload.
 */
async function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

function httpStatus(err: unknown): number | undefined {
  const e = err as { response?: { status?: number }; statusCode?: number }
  return e.response?.status ?? e.statusCode
}

async function withRetry429<T>(fn: () => Promise<T>, label: string, maxAttempts = 6): Promise<T> {
  let lastErr: unknown
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      return await fn()
    } catch (err: unknown) {
      lastErr = err
      const status = httpStatus(err)
      if (status !== 429 || attempt === maxAttempts) throw err
      const delayMs = Math.min(3000 * 2 ** (attempt - 1), 45000)
      console.warn(`${label}: rate limited (429), retrying in ${delayMs}ms (${attempt}/${maxAttempts})`)
      await sleep(delayMs)
    }
  }
  throw lastErr
}

export async function uploadFileViaPresignedPut(file: File): Promise<string | null> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('module', 'bulk-upload')
  formData.append('entity', 'pod')

  const res = await withRetry429(
    () => filesApi.uploadFile(formData),
    `upload for ${file.name}`
  )

  const payload =
    (res as { data?: { data?: { url?: string } } }).data?.data
    ?? (res as { data?: { url?: string } }).data

  return payload?.url ?? null
}
